import { render, staticRenderFns } from "./ElementosDeIdentidadCorporativa.vue?vue&type=template&id=592189d7"
import script from "./ElementosDeIdentidadCorporativa.vue?vue&type=script&lang=js"
export * from "./ElementosDeIdentidadCorporativa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports